import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link } from '@mui/material';
import Content from '../layout/content-box/Content';
import Templecard from '../layout/tamplecard/Templecard';
import { useEffect, useState } from 'react';
import axios from 'axios'; // If you're using axios

export default function DetailListing() {
 
  const templeData = [
      { image: '/assets/tample/tample11.svg', name: 'Dwarkadhish', link:"dwarkadhish-temple" },
      { image: '/assets/tample/ayodhya-temple.svg', name: 'Ayodhya', link:"ayodhya" },
      { image: '/assets/tample/tample9.svg', name: 'Kashi Vishwanath', link:"kashi-vishwanath" },
      { image: '/assets/tample/tample12.svg', name: 'Rameswaram', link:"ramanathaswamy-temple" },
  { image: '/assets/tample/tample3.svg', name: 'Vaishno Devi', link:"vaishno-devi" },
  
];
  return (
    <>
    <Box className="aboutBanner contactBanner" >
            <Container maxWidth="md">
              <Grid container spacing={2} justifyContent="left" alignItems="center">
                <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                  <Box className="bannerText text-center refundHeading">
                    <h1 className="mb-1">{Content[0].templeHeading}</h1>
                    <span>{Content[0].templeSubHeading}</span>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
     <Box className="templeBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center">
            
            {templeData.map((temple, index) => (
              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Link href={temple.link}><Templecard key={index} image={temple.image} name={temple.name} /></Link>
              </Grid>
            ))}
          

           <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className="exciting-news-banner">
      <span className="icon">✨</span>
      <strong>Exciting News!</strong>&nbsp;&nbsp;
      <span className="text">We are adding more temples soon.</span>
    </div>
           </Grid>
          </Grid>
        </Container>
      </Box>
      
    </>
  );
}
